// extracted by mini-css-extract-plugin
module.exports = {"form_container":"SetNewPasswordForm_form_container__zxMim","succeded_reset":"SetNewPasswordForm_succeded_reset__3jlm1","link":"SetNewPasswordForm_link__ZH-V7"};